module.exports = __webpack_public_path__ + "img/banner_left.e8902f14.jpg";